import { EventTypes } from '../../../constants';

const DEFAULT_MESSAGES = {
  [EventTypes.OPT_OUT]: '',
  [EventTypes.HELP]: '',
  [EventTypes.JOIN]: '',
  [EventTypes.WELCOME]: '',
};

const DEFAULT_KEYWORDS = {
  [EventTypes.OPT_OUT]: ['stop'],
  [EventTypes.HELP]: ['help'],
  [EventTypes.JOIN]: ['join'],
};

export { DEFAULT_KEYWORDS, DEFAULT_MESSAGES };
